export default function BeatBattleIcon() {
  const chevron = 'M0 -5.5 L5.5 0.5 L3 3 L0 -0.5 L-3 3 L-5.5 0.5 Z';
  const gems: Array<[number, number, number, string]> = [
    [14, 20, -90, '#ff8a1f'],
    [26, 26, 180, '#ffd23a'],
    [38, 18, 0, '#2fd3c4'],
    [50, 24, 90, '#ff5fa2'],
  ];
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#2a1060" />
      <circle cx="32" cy="32" r="22" fill="#6b2bd6" opacity="0.5" />
      {gems.map(([x, y, r, c]) => (
        <g key={x} transform={`translate(${x} ${y}) rotate(${r})`}>
          <circle r="8" fill={c} stroke="#111" strokeWidth="2" />
          <path d={chevron} fill="#fff" stroke="#111" strokeWidth="1" strokeLinejoin="round" />
        </g>
      ))}
      <rect x="27" y="36" width="10" height="16" rx="5" fill="#ffe9f3" stroke="#111" strokeWidth="2" />
      <path d="M22 46c0 6 5 9 10 9s10-3 10-9" stroke="#ffd34d" strokeWidth="3" fill="none" strokeLinecap="round" />
      <rect x="30.5" y="54" width="3" height="5" fill="#ffd34d" />
    </svg>
  );
}
